<script>
import config from '../../common/genericPanelConf';
import EquipmentOperationService from '../../services/equipment-operation';
import Dialog from 'primevue/dialog';
import ResponsiveButton from '../../components/generic/ResponsiveButton.vue'
import Utils from '../../common/Utils';
import LabelField from '../../components/generic/LabelField.vue'

export default {
    props: ['visible', 'tankCode'],
    emits: ["close-tank-information"],
    components: {
        Dialog, LabelField
    },
    created(){
        this.config = config.getConfiguration('biodieselMixingReport');
    },
    mounted(){
        this.loadTankInfo();
    },
    data(){
        return{
            generalTankInfo: {},
            filters:{
                tankCode: this.tankCode
            }
        }
    },
    computed: {
         constants(){
            return CommonConstants;
        },
        utils(){
            return Utils;
        },
    },
    watch: {
        'tankCode'(){
            this.filters.tankCode = this.tankCode;
            this.loadTankInfo();
        }
    },
    methods: {
        closeDialog(value) {
            this.$emit("close-tank-information", value);
        },
       loadTankInfo(){
            let body = {
                tankCode: this.filters.tankCode
            }
           
            EquipmentOperationService.equipmentOperationTankInfo(body, (response) => {
                this.$store.dispatch("generic/setLoading", false);
                if(response.success){
                   this.generalTankInfo = response.data;

                   if(this.generalTankInfo.tankContentLayersList){
                    for(let i = 0; i < this.generalTankInfo.tankContentLayersList.length; i++){
                        let item = this.generalTankInfo.tankContentLayersList[i];
                        item.introductionDate = item.introductionDate ? Utils.dateToCurrentTimeZone(item.introductionDate) : null;
                    }
                   }                  
                }
            })
        }
    }
}
</script>

<template>
    <main>
        <Dialog :visible="visible" :header="$t('tankOperations.tankContent')" :style="{ width: '110rem' }">
             <div class="grid">
                <Button icon="pi pi-times" class="p-button-sm close-button" @click="closeDialog(true)" />
              </div>
            <div class="grid" style="padding: 1%;">
                <div class="col-12 lg:col-2">
                    <LabelField class="w-full" :value="generalTankInfo.tankCode" :label="$t('tankOperations.tank')"/>                   
                </div>
                <div class="col-12 lg:col-4">
                    <LabelField class="w-full" :value="generalTankInfo.totalAccountingStockWeight" :label="$t('tankOperations.totalAccountingStockWeight')"/>
                    <LabelField class="w-full" :value="generalTankInfo.totalFiscalStockWeight" :label="$t('tankOperations.totalFiscalStockWeight')"/>
                </div>
                <div class="col-12 lg:col-4">
                    <LabelField class="w-full" :value="generalTankInfo.totalAccountingStockVolume" :label="$t('tankOperations.totalAccountingStockVolume')"/>
                    <LabelField class="w-full" :value="generalTankInfo.totalFiscalStockVolume" :label="$t('tankOperations.totalFiscalStockVolume')"/>
                </div>
                <div class="col-12 lg:col-2">
                    <LabelField class="w-full" :value="generalTankInfo.averageDensity15Deg" :label="$t('tankOperations.averageDensity15Deg')"/>                   
                </div>
            </div>

            <div class="grid">
                <Panel class="w-full my-3" :header="$t('tankOperations.contentProductFamilies')" toggleable>
                    <DataTable :value="generalTankInfo.tankContentLayerByFamily" scrollable scrollHeight="flex" :sortOrder="1" size="small" dataKey="id" >
                        <Column style="min-width: 50px;" field="combinedNomenclature" :header="$t('tankOperations.combinedNomenclature')" />
                        <Column style="min-width: 120px;" field="accountingStockWeight" :header="$t('tankOperations.accountingStockWeight')" />
                        <Column style="min-width: 120px;" field="accountingStockWeightPercentage" :header="$t('tankOperations.accountingStockWeightPercentage')" />
                        <Column style="min-width: 120px;" field="accountingStockVolume" :header="$t('tankOperations.accountingStockVolume')" />
                        <Column style="min-width: 120px;" field="accountingStockVolumePercentage" :header="$t('tankOperations.accountingStockVolumePercentage')" />
                        <Column style="min-width: 120px;" field="fiscalStockWeight" :header="$t('tankOperations.fiscalStockWeight')" />
                        <Column style="min-width: 120px;" field="fiscalStockWeightPercentage" :header="$t('tankOperations.fiscalStockWeightPercentage')" />
                        <Column style="min-width: 120px;" field="fiscalStockVolume" :header="$t('tankOperations.fiscalStockVolume')" />
                        <Column style="min-width: 120px;" field="fiscalStockVolumePercentage" :header="$t('tankOperations.fiscalStockVolumePercentage')" />
                    </DataTable>
                </Panel>              
            </div>

            <div class="grid">
                <Panel class="w-full my-3" :header="$t('tankOperations.productDetails')" toggleable>
                    <DataTable :value="generalTankInfo.tankContentLayersList" scrollable scrollHeight="flex" :sortOrder="1" size="small" dataKey="id" >
                        <Column style="min-width: 50px;" field="productCode" :header="$t('tankOperations.productCode')" />
                        <Column style="min-width: 120px;" field="productDescription" :header="$t('tankOperations.productDescription')" />
                        <Column style="min-width: 120px;" field="combinedNomenclature" :header="$t('tankOperations.combinedNomenclature')" />
                        <Column style="min-width: 120px;" field="introductionDate" :header="$t('tankOperations.introductionDate')">
                            <template #body="{ data, field }">
                                <span>{{data[field] != null ? utils.formatDateTime(utils.dateToCurrentTimeZone(data[field])) : null}}</span>
                            </template>
                        </Column>
                        <Column style="min-width: 120px;" field="densityAt15Deg" :header="$t('tankOperations.density15')" />
                        <Column style="min-width: 120px;" field="accountingStockWeight" :header="$t('tankOperations.accountingStockWeight')" />
                        <Column style="min-width: 120px;" field="accountingStockWeightPercentage" :header="$t('tankOperations.accountingStockWeightPercentage')" />
                        <Column style="min-width: 120px;" field="fiscalStockWeight" :header="$t('tankOperations.fiscalStockWeight')" />
                        <Column style="min-width: 120px;" field="fiscalStockWeightPercentage" :header="$t('tankOperations.fiscalStockWeightPercentage')" />
                    </DataTable>
                </Panel>              
            </div>
        </Dialog>
    </main>
</template>

<style>
.close-button{
    position: absolute;
    top: 21px;
    right: 21px;
  }
</style>
